import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  CreateUpdateRevenueAndExpenseDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_REVENUE_AND_EXPENSES } from "../domain";

import { revenueAndExpensesApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_UPDATE_REVENUE_AND_EXPENSE =
  "CREATE_UPDATE_REVENUE_AND_EXPENSE";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type CreateUpdateRevenueAndExpenseRequest = CreateUpdateRevenueAndExpenseDto[];

const createUpdateRevenueAndExpense = async (
  data: CreateUpdateRevenueAndExpenseDto[],
): Promise<void> => {
  const response =
    await revenueAndExpensesApi.revenueAndExpensesControllerCreateUpdateRevenueAndExpenses(
      data,
    );

  return response.data;
};

export const useCreateUpdateRevenueAndExpense = (
  user: UserProfileDto | null,
): {
  createUpdateRevenueAndExpense: (
    data: CreateUpdateRevenueAndExpenseRequest,
  ) => void;
  createUpdateRevenueAndExpenseEnabled: boolean;
  isSuccessCreateUpdateRevenueAndExpense: boolean;
  isPendingCreateUpdateRevenueAndExpense: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [
      DOMAIN_REVENUE_AND_EXPENSES,
      ACTION_CREATE_UPDATE_REVENUE_AND_EXPENSE,
    ],
    mutationFn: enabled ? createUpdateRevenueAndExpense : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_REVENUE_AND_EXPENSES] });
    },
  });

  return {
    createUpdateRevenueAndExpense: mutate,
    createUpdateRevenueAndExpenseEnabled: enabled,
    isSuccessCreateUpdateRevenueAndExpense: isSuccess,
    isPendingCreateUpdateRevenueAndExpense: isPending,
  };
};
